import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'store_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
  {
    path: 'new',
    name: 'store_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'store_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'store_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
